import {
    Wrench,
    Zap,
    Paintbrush,
    Fence,
    Package,
    Tv,
    DoorOpen,
    Hammer,
    ArrowRight,
} from "lucide-react";
import { BUSINESS } from "../lib/business";

const SERVICES = [
    {
        icon: Wrench,
        title: "Plumbing",
        desc: "Leaks, taps, toilets, basins, blockages and minor pipework — sorted quickly.",
    },
    {
        icon: Zap,
        title: "Electrical",
        desc: "Sockets, switches, light fittings and small electrical jobs done safely.",
    },
    {
        icon: Paintbrush,
        title: "Decorating",
        desc: "Clean painting, filling, sanding and small interior touch-ups.",
    },
    {
        icon: Fence,
        title: "Fencing",
        desc: "Fence panels, posts and gates repaired or replaced — built to last.",
    },
    {
        icon: Package,
        title: "Flat-Pack Furniture",
        desc: "IKEA, Wayfair and beyond — assembled properly the first time.",
    },
    {
        icon: Tv,
        title: "TV Mounting",
        desc: "TVs hung level, cables tidied. Brick, plasterboard or stud — no problem.",
    },
    {
        icon: DoorOpen,
        title: "Hanging Doors",
        desc: "Internal doors fitted, planed and hung so they close just right.",
    },
    {
        icon: Hammer,
        title: "Odd Jobs",
        desc: "Shelves, curtain poles, mirrors, picture hanging and that list on the fridge.",
    },
];

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-24 md:py-32 bg-slate-50"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <div className="text-xs uppercase tracking-[0.2em] text-amber-700 font-bold mb-4">
                        What we do
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
                        One trusted tradesman for every job on the list.
                    </h2>
                    <p className="mt-5 text-lg text-slate-600 leading-relaxed">
                        Save time and the hassle of finding multiple
                        tradesmen. From quick fixes to full afternoons of
                        work, here are the services we handle every day.
                    </p>
                </div>

                <div
                    className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
                    data-testid="services-grid"
                >
                    {SERVICES.map(({ icon: Icon, title, desc }) => (
                        <div
                            key={title}
                            data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                            className="group relative bg-white border border-slate-200 rounded-xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-amber-200"
                        >
                            <div className="w-12 h-12 rounded-lg bg-slate-900 group-hover:bg-amber-600 flex items-center justify-center mb-5 transition-colors">
                                <Icon className="w-6 h-6 text-white" />
                            </div>
                            <h3 className="font-display text-xl font-bold text-slate-900">
                                {title}
                            </h3>
                            <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                                {desc}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4 p-6 bg-white border border-slate-200 rounded-xl">
                    <div className="flex-1">
                        <div className="font-display text-xl font-bold text-slate-900">
                            Job not listed? Just ask.
                        </div>
                        <p className="text-sm text-slate-600 mt-1">
                            If it&apos;s practical, hands-on and around the
                            home — there&apos;s a good chance we can help.
                        </p>
                    </div>
                    <a
                        href={`tel:${BUSINESS.phoneTel}`}
                        data-testid="services-call-cta"
                        className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm transition-colors shrink-0"
                    >
                        Talk to us
                        <ArrowRight className="w-4 h-4" />
                    </a>
                </div>
            </div>
        </section>
    );
}
